import { useCreditInfo } from '@/lib/hooks'
import { isFairgenInternalTier } from '@/lib/billing/tier'
import { CreditIcon } from '@/components/icons/CreditIcon'

interface CreditWalletBadgeProps {
  tier: string | null | undefined
}

export function CreditWalletBadge({ tier }: CreditWalletBadgeProps) {
  const { data: creditData, isLoading } = useCreditInfo()

  if (isLoading || !creditData) {
    return null
  }

  const display = isFairgenInternalTier(tier)
    ? 'Unlimited'
    : creditData.available.toLocaleString()

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-muted/60 dark:bg-muted/40 px-2 py-0.5 text-[14px] font-medium text-muted-foreground"
      data-testid="sidebar-credit-wallet"
    >
      <CreditIcon className="h-3.5 w-3.5 shrink-0" strokeWidth={1} />
      <span>{display}</span>
    </span>
  )
}
